import * as React from 'react';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import { useAuth } from '@providers/AuthProvider';
import { authenticatedApi } from 'api';
import toast from 'react-hot-toast';
import ConfettiExplosion from 'react-confetti-explosion';

export function Announcement() {
  const { user, setUser } = useAuth();

  const [open, setOpen] = React.useState<boolean>(!!user?.unseen_announcement);
  const [exploding, setExploding] = React.useState<boolean>(false);

  React.useEffect(() => {
    setOpen(!!user?.unseen_announcement);
  }, [user])

  const setAnnouncementSeen = () => {
    // todo: api request
    authenticatedApi.put(`/announcement-seen/${user.unseen_announcement.id}`).then(function() {
      setOpen(false);

      const _user = {...user};
      _user.unseen_announcement = null;
      setUser(_user);

      setExploding(true);
      setTimeout(() => {
        setExploding(false);
      }, 2200);
    });
  };

  if(!user?.unseen_announcement) {
    // return null;
  }

  return (
    <React.Fragment>
      {exploding && (<>
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <ConfettiExplosion />
        </div>
      </>)}
      <Modal
        open={open}
        // onClose={setAnnouncementSeen}
      >
        <ModalDialog
          variant="plain"
          role="alertdialog"
          sx={{
            color: '#000',
            backgroundImage: `
              linear-gradient(
                180deg,
                hsl(0deg 67% 95%) 0%,
                hsl(0deg 67% 96%) 10%,
                hsl(0deg 68% 97%) 20%,
                hsl(0deg 68% 98%) 30%,
                hsl(0deg 69% 99%) 40%,
                hsl(0deg 0% 100%) 50%,
                hsl(300deg 100% 100%) 60%,
                hsl(300deg 100% 100%) 70%,
                hsl(300deg 100% 100%) 80%,
                hsl(300deg 100% 100%) 90%,
                hsl(0deg 0% 100%) 100%
              )
            `
          }}
        >
          <DialogTitle>
            <CampaignRoundedIcon sx={{color: '#000'}} />
            {user?.unseen_announcement?.title}
          </DialogTitle>
          <Divider />
          <DialogContent sx={{color: '#000'}}>
            <div dangerouslySetInnerHTML={{__html: user?.unseen_announcement?.content}}></div>
          </DialogContent>
          <DialogActions sx={{justifyContent: 'center'}}>
            <Button
                variant="solid"
                // color="primary"
                onClick={setAnnouncementSeen}
                sx={{
                  flex: '0 0 auto !important',
                }}
            >
              Got it!
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}
